import { on, select, selectAll, addClass, removeClass, hasClass, setAttribute, getAttribute, toggleClass } from 'modules/dom'
import { map } from 'modules/utils'
import debounce from 'lodash.debounce';

const body = document.body
const ACTIVATE_CLASS = 'search-resource-visible'
const ACTIVATE_SELECT_CLASS = 'active-select'

const SEARCH_TOGGLE_BUTTON_CLASS = '.js-search-resource-button'
const SEARCH_CLOSE_BUTTON_CLASS = '.js-search-resource-button-close'
const SEARCH_RESOURCE_FILTER_FORM_CLASS = '.js-search-resource-filter-form'

const SEARCH_RESOURCE_GRADES_CLASS = '.js-search-resource-grades'
const SEARCH_RESOURCE_GRADES_SELECT_CLASS = '.js-resource-grades-select'
const SEARCH_RESOURCE_GRADES_SELECT_TEXT_CLASS = '.js-resource-grades-select-text'
const SEARCH_RESOURCE_GRADES_RADIO_INPUT_CLASS = '.js-field__radio input'
const SEARCH_RESOURCE_GRADES_RADIO_CLASS = '.js-field__radio'

const SEARCH_RESOURCE_CONCEPTS_CLASS = '.js-search-resource-concepts'
const SEARCH_RESOURCE_CONCEPTS_SELECT_CLASS = '.js-resource-concepts-select'
const SEARCH_RESOURCE_CONCEPTS_SELECT_TEXT_CLASS = '.js-resource-concepts-select-text'
const SEARCH_RESOURCE_CONCEPTS_CHECKBOX_INPUT_CLASS = '.js-field__checkbox input'

const APPLY_GRADES_CLASS = '.js-apply-grades'
const CLEAR_GRADES_CLASS = '.js-clear-grades'

const APPLY_CONCEPTS_CLASS = '.js-apply-concepts'
const CLEAR_CONCEPTS_CLASS = '.js-clear-concepts'

const CHECKBOX_INPUT_CHECKED_CLASS = '.js-field__checkbox input:checked'
const CHECKBOX_ALL_CLASS = 'input[data-value="all"]'
const CHECKBOX_NOT_ALL_CLASS = 'input:not([data-value="all"])'

export default function (el) {
  const searchToggleButtonEl = select(SEARCH_TOGGLE_BUTTON_CLASS, el)
  const searchCloseButtonEl = select(SEARCH_CLOSE_BUTTON_CLASS, el)
  const searchFilterFormEl = select(SEARCH_RESOURCE_FILTER_FORM_CLASS, el)

  const searchGradesEl = select(SEARCH_RESOURCE_GRADES_CLASS, el)
  const searchGradesSelectEl = select(SEARCH_RESOURCE_GRADES_SELECT_CLASS, el)
  const searchGradesSelectTextEl = select(SEARCH_RESOURCE_GRADES_SELECT_TEXT_CLASS, el)
  const searchGradesRadioEls = selectAll(SEARCH_RESOURCE_GRADES_RADIO_INPUT_CLASS, el)

  const searchConceptsEl = select(SEARCH_RESOURCE_CONCEPTS_CLASS, el)
  const searchConceptsSelectEl = select(SEARCH_RESOURCE_CONCEPTS_SELECT_CLASS, searchConceptsEl)
  const searchConceptsSelectTextEl = select(SEARCH_RESOURCE_CONCEPTS_SELECT_TEXT_CLASS, searchConceptsEl)
  const searchConceptsCheckboxEls = selectAll(SEARCH_RESOURCE_CONCEPTS_CHECKBOX_INPUT_CLASS, searchConceptsEl)

  const applyGradesEl = select(APPLY_GRADES_CLASS, el)
  const clearGradesEl = select(CLEAR_GRADES_CLASS, el)

  const applyConceptsEl = select(APPLY_CONCEPTS_CLASS, el)
  const clearConceptsEl = select(CLEAR_CONCEPTS_CLASS, el)

  const checkboxAll = selectAll(CHECKBOX_ALL_CLASS, el)
  const checkboxNotAll = selectAll(CHECKBOX_NOT_ALL_CLASS, el)

  const activateSidebarDetail = () => addClass(ACTIVATE_CLASS, body)
  const deactivateSidebarDetail = () => removeClass(ACTIVATE_CLASS, body)

  on('resize', debounce(() => {
    if (window.innerWidth >= 768) {
      deactivateSidebarDetail()
    }
  }), window)

  const activeGradesSelect = () => {
    toggleClass(ACTIVATE_SELECT_CLASS, searchGradesEl)

    removeClass(ACTIVATE_SELECT_CLASS, searchConceptsEl)
  }
  const activeConceptsSelect = () => {
    toggleClass(ACTIVATE_SELECT_CLASS, searchConceptsEl)

    removeClass(ACTIVATE_SELECT_CLASS, searchGradesEl)
  }

  if (searchFilterFormEl) {
    setAttribute('action', '/resources/', searchFilterFormEl)
  }
  if (searchToggleButtonEl) {
    on('click', activateSidebarDetail, searchToggleButtonEl)
  }
  if (searchCloseButtonEl) {
    on('click', deactivateSidebarDetail, searchCloseButtonEl)
  }

  const links = selectAll('.js-resource-link', el)
  if (links.length > 0) {
    links.map((link, index) => {
      on('focus', function (e) {
        const target = e.target
        const parentGrades = target.closest(SEARCH_RESOURCE_GRADES_CLASS)
        const parentConcepts = target.closest(SEARCH_RESOURCE_CONCEPTS_CLASS)
        if (parentGrades) {
          activeGradesSelect()
          setAttribute('aria-expanded', true, parentGrades)
          setAttribute('aria-expanded', false, searchConceptsEl)
        }
        if (parentConcepts) {
          activeConceptsSelect()
          setAttribute('aria-expanded', true, parentConcepts)
          setAttribute('aria-expanded', false, searchGradesEl)
        }
      }, link)
    }, links)
  }

  if (searchGradesSelectEl) {
    on('click', activeGradesSelect, searchGradesSelectEl)
  }
  if (searchConceptsSelectEl) {
    on('click', activeConceptsSelect, searchConceptsSelectEl)
  }

  // apply & clear button
  if (applyGradesEl) {
    const handleApplyGrades = (e) => {
      e.preventDefault()
      removeClass(ACTIVATE_SELECT_CLASS, searchGradesEl)
      setAttribute('aria-expanded', false, searchGradesEl)
    }
    on('click', handleApplyGrades, applyGradesEl)
    on('keyup', function (e) {
      if(e.keyCode == 13 || e.which == 13) {
        handleApplyGrades(e)
      }
    }, applyGradesEl)
  }
  if (clearGradesEl) {
    const handleClearGrades = (e) => {
      e.preventDefault()
      removeClass(ACTIVATE_SELECT_CLASS, searchGradesEl)
      setAttribute('aria-expanded', false, searchGradesEl)
      searchGradesSelectTextEl.innerHTML = 'All Grades'

      const target = e.target
      const parent = target.closest('.search-resource__item')
      const menuTextEl = select('.js-count', parent)
      menuTextEl.innerHTML = ''

      if (searchGradesRadioEls.length > 0) {
        map(radioEl => {
          radioEl.checked = false
        }, searchGradesRadioEls)
      }
    }
    on('click', handleClearGrades, clearGradesEl)
    on('keyup', (e) => {
      if (e.keyCode == 13 || e.which == 13) {
        handleClearGrades(e)
      }
    }, clearGradesEl)
  }

  if (applyConceptsEl) {
    const handleApplyConcepts = (e) => {
      e.preventDefault()
      removeClass(ACTIVATE_SELECT_CLASS, searchConceptsEl)
      setAttribute('aria-expanded', false, searchConceptsEl)
      if (searchConceptsCheckboxEls.length > 0) {
        let count = 0
        map(checkboxEl => {
          if (checkboxEl.checked) {
            count++;
          }
        }, searchConceptsCheckboxEls)
        if (count > 0) {
          searchConceptsSelectTextEl.innerHTML = '(' + count + ')'
        }
      }
    }
    on('click', handleApplyConcepts, applyConceptsEl)
    on('keyup', (e) => {
      if (e.keyCode == 13 || e.which == 13) {
        handleApplyConcepts(e)
      }
    }, applyConceptsEl)
  }
  if (clearConceptsEl) {
    const handleClearConcepts = (e) => {
      const target = e.target
      const parent = target.closest('.search-resource__item')
      const checkboxes = selectAll('input', parent)
      const countEls = selectAll('.js-count', parent)
      e.preventDefault()
      removeClass(ACTIVATE_SELECT_CLASS, searchConceptsEl)
      setAttribute('aria-expanded', false, searchConceptsEl)
      searchConceptsSelectTextEl.innerHTML = ''
      if (parent && checkboxes.length > 0) {
        map(checkboxEl => {
          checkboxEl.checked = false
        }, checkboxes)
        if (countEls.length > 0) {
          map(countEl => {
            countEl.innerHTML = ''
          }, countEls)
        }
      }
    }
    on('click', handleClearConcepts, clearConceptsEl)
    on('keyup', (e) => {
      if (e.keyCode == 13 || e.which == 13) {
        handleClearConcepts(e)
      }
    }, clearConceptsEl)
  }

  // Grades radio on change
  if (searchGradesRadioEls.length > 0) {
    map(radioEl => {
      on('change', (e) => {
        const target = e.target;
        const parent = target.closest('.search-resource__item')
        const label = getAttribute('data-value', target.closest(SEARCH_RESOURCE_GRADES_RADIO_CLASS))
        searchGradesSelectTextEl.innerHTML = label
        const menuTextEl = select('.js-count', parent)
        if (menuTextEl) {
          menuTextEl.innerHTML = ' (1)'
        }
        activeFilterButtons()
      }, radioEl)
    }, searchGradesRadioEls)
  }

  // on keydown checked radio
  const keyupRadioEls = selectAll(SEARCH_RESOURCE_GRADES_RADIO_CLASS, el)
  if (keyupRadioEls.length > 0) {
    map(radioEl => {
      on('keydown', (e) => {
        const target = e.target
        if ((e.keyCode == 32 || e.which == 32) && target == radioEl) {
          const inputEl = select('input', target)
          inputEl.checked = true

          const parent = target.closest('.search-resource__item')
          const label = getAttribute('data-value', target.closest(SEARCH_RESOURCE_GRADES_RADIO_CLASS))
          searchGradesSelectTextEl.innerHTML = label
          const menuTextEl = select('.js-count', parent)
          if (menuTextEl) {
            menuTextEl.innerHTML = ' (1)'
          }
          activeFilterButtons()
          e.preventDefault()
        }
      }, radioEl)
    }, keyupRadioEls)
  }

  // last focus un active select topic
  if (clearConceptsEl) {
    on('focusout', function (e) {
      if (searchConceptsEl) {
        removeClass(ACTIVATE_SELECT_CLASS, searchConceptsEl)
        setAttribute('aria-expanded', false, searchConceptsEl)
      }
    }, clearConceptsEl)
  }

  // count checked on change dropdown concepts
  if (searchConceptsCheckboxEls.length > 0) {
    map(checkboxEl => {
      on('change', (e) => {
        const count = selectAll(CHECKBOX_INPUT_CHECKED_CLASS, searchConceptsEl).length
        if (count > 0) {
          searchConceptsSelectTextEl.innerHTML = '(' + count + ')'
        } else {
          searchConceptsSelectTextEl.innerHTML = ''
        }
      }, checkboxEl)
    }, searchConceptsCheckboxEls)
  }

  // click outside close popup dropdown
  document.addEventListener('click', (e) => {
    const target = e.target
    const parentGradesEl = select('.search-resource__grades', el)
    if (!parentGradesEl.contains(target)) {
      removeClass(ACTIVATE_SELECT_CLASS, searchGradesEl)
    }
    const parentConceptsEl = select('.search-resource__concepts', el)
    if (!parentConceptsEl.contains(target)) {
      removeClass(ACTIVATE_SELECT_CLASS, searchConceptsEl)
    }
  })

  // Handle checkbox all
  if (checkboxAll.length > 0) {
    map(checkboxEl => {
      // Prevent expand/collapse when click on checkbox
      on('click', (e) => {
        e.stopPropagation()
      }, checkboxEl)

      on('change', (e) => {
        const target = e.target
        const parent = target.closest('.js-item')
        const parentList = target.closest('.js-search-resource-concepts')
        const checkboxes = selectAll('input[type="checkbox"]', parent)

        if (target.checked) {
          map(checkboxEl => {
            checkboxEl.checked = true
            if (hasClass('unchecked', checkboxEl)) {
              removeClass('unchecked', checkboxEl)
            }
          }, checkboxes)
        } else {
          map(checkboxEl => {
            checkboxEl.checked = false
          }, checkboxes)
        }
        // update count item
        countItemsChecked(parent, parentList)
        activeFilterButtons()
      }, checkboxEl)
    }, checkboxAll)
  }

  // Handle checkbox not value all
  if (checkboxNotAll.length > 0) {
    map(checkboxEl => {
      on('click', (e) => e.stopPropagation(), checkboxEl)
      on('change', (e) => {
        const target = e.target
        const parent = target.closest('.js-item')
        const parentList = target.closest('.js-search-resource-concepts')
        uncheckedParent(target)
        countItemsChecked(parent, parentList)
        activeFilterButtons()
      }, checkboxEl)
    }, checkboxNotAll)
  }

  const uncheckedParent = (inputChildEl) => {
    if (inputChildEl) {
      const target = inputChildEl
      const parent = target.closest('.js-item')
      if (parent) {
        const itemHeadingEl = select('.js-toggle', parent)
        const parentCheckbox = select('input[type="checkbox"]', itemHeadingEl)
        const childCheckboxes = selectAll('.js-field__checkbox > input[type="checkbox"]', parent)
        const childCheckBoxesIsChecked = selectAll('.js-field__checkbox > input[type="checkbox"]:checked', parent)
        if (childCheckboxes.length === childCheckBoxesIsChecked.length) {
          parentCheckbox.checked = true
        } else {
          parentCheckbox.checked = false
        }

        if (childCheckBoxesIsChecked.length > 0 && childCheckboxes.length !== childCheckBoxesIsChecked.length) {
          addClass('unchecked', parentCheckbox)
        } else {
          removeClass('unchecked', parentCheckbox)
        }
      }
    }
  }

  const countItemsChecked = (parent, parentList) => {
    // count checked list in item
    if (parent) {
      const itemsEl = selectAll('.js-item input:not([data-value="all"]):checked', parent)
      const countEl = select('.js-count', parent)
      if (itemsEl.length > 0) {
        countEl.innerHTML = ' (' + itemsEl.length + ')'
      } else {
        countEl.innerHTML = ''
      }
    }
    // count checked list in item accordion
    if (parentList) {
      const parentItems = selectAll('.js-search-resource-concepts input:not([data-value="all"]):checked', parentList)
      const countParentEl = select('.js-count', parentList)
      if (parentItems.length > 0 && searchConceptsSelectTextEl) {
        searchConceptsSelectTextEl.innerHTML = ' (' + parentItems.length + ')'
        countParentEl.innerHTML = ' (' + parentItems.length + ')'
      } else {
        searchConceptsSelectTextEl.innerHTML = ''
        countParentEl.innerHTML = ''
      }
    }
  }

  // mobile click item show side out sub-menu
  const parentMenuEls = selectAll('.js-search-resource-parent-menu', el)
  if (parentMenuEls.length > 0) {
    map(parentMenuEl => {
      on('click', (e) => {
        e.preventDefault()
        const target = e.target
        const parent = target.closest('.search-resource__item')
        const submenu = select('.js-search-resource-sub-menu', parent)
        if (parent && submenu) {
          addClass('active', submenu)
        }
      }, parentMenuEl)
    }, parentMenuEls)
  }

  // mobile close side out sub-menu
  const closeSideOutEls = selectAll('.js-accordion-close-sideout', el)
  if (closeSideOutEls.length > 0) {
    map((closeSideOutEl) => {
      if (closeSideOutEl) {
        on('click', function (e) {
          const target = e.target
          const parent = target.closest('.js-search-resource-sub-menu')
          if (parent) {
            removeClass('active', parent)
          }
        }, closeSideOutEl)
      }
    }, closeSideOutEls)
  }

  // mobile filter buttons
  const activeFilterButtons = () => {
    const checkedCheckboxes = selectAll('.js-field__checkbox > input:checked', el)
    const checkedRadios = selectAll('.js-field__radio > input:checked', el)
    const filterButtons = selectAll('.js-field-filter-buttons', el)

    if (checkedCheckboxes.length > 0 || checkedRadios.length > 0) {
      if (filterButtons.length > 0) {
        map(filterButton => {
          addClass('active', filterButton)
        }, filterButtons)
      }
    } else {
      if (filterButtons.length > 0) {
        map(filterButton => {
          removeClass('active', filterButton)
        }, filterButtons)
      }
    }
  }

  // clear all checked on mobile
  const clearEl = select('.js-field-filter-clear', el)
  if (clearEl) {
    on('click', (e) => {
      e.preventDefault()
      // clear all checked
      const checkboxes = selectAll('input[type="checkbox"]', el)
      const radios = selectAll('input[type="radio"]', el)
      if (checkboxes.length > 0) {
        map(checkbox => {
          checkbox.checked = false
        }, checkboxes)
      }
      if (radios.length > 0) {
        map(radio => {
          radio.checked = false
        }, radios)
      }
      activeFilterButtons()
      // clear count
      const countEls = selectAll('.js-count', el)
      if (countEls.length > 0) {
        map(countEl => {
          countEl.innerHTML = ''
        }, countEls)
      }
      if (searchConceptsSelectTextEl) {
        searchConceptsSelectTextEl.innerHTML = ''
      }
      if (searchGradesSelectTextEl) {
        searchGradesSelectTextEl.innerHTML = 'All Grades'
      }
    }, clearEl)
  }
}
